import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=d684007e&scoped=true&"
import script from "./Img.vue?vue&type=script&lang=js&"
export * from "./Img.vue?vue&type=script&lang=js&"
import style0 from "./Img.vue?vue&type=style&index=0&id=d684007e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d684007e",
  null
  
)

export default component.exports